import { SensorType } from "constant/gateway";

// Sensor CLS to Sensor Type mapping
const SENSOR_CLS_TYPE_MAP = {
    "3080": SensorType.WaterConsumption,
    "2824": SensorType.EnergyConsumption,
} as const;

const SENSOR_TYPE_CLS_MAP = Object.fromEntries(
    Object.entries(SENSOR_CLS_TYPE_MAP).map(([cls, type]) => [type, cls])
) as Record<SensorType, string>;

const getSensorTypeByCLS = (cls: string): SensorType | null => {
    return SENSOR_CLS_TYPE_MAP[cls as keyof typeof SENSOR_CLS_TYPE_MAP] ?? null;
};

const getCLSBySensorType = (sensorType: SensorType): string | null => {
    return SENSOR_TYPE_CLS_MAP[sensorType] ?? null;
};

/**
 * Get sensor type from sensor object
 * @param sensor - Sensor object with CLS property
 * @returns SensorType or null if not found
 */
export const getSensorType = (
    sensor: {
        CLS: string;
    } & Record<string, any>
): SensorType | null => {
    return getSensorTypeByCLS(sensor?.CLS);
};

/**
 * Get CLS code from metric name for consumption charts
 * @param metric - Metric name to check
 * @returns CLS code string
 */
export const getConsumptionCLSFromMetricName = (metric: string): string => {
    if (metric.toLowerCase().includes("kw")) {
        return getCLSBySensorType(SensorType.EnergyConsumption) ?? "";
    }
    return getCLSBySensorType(SensorType.WaterConsumption) ?? "";
};
